import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { useViewType, ViewType } from '@eika/hooks';
import { DarkSkeleton } from '@eika/skeleton';

import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useBankInfo from '../../fetchHooks/useBankInfo';
import useProfile from '../../fetchHooks/useProfile';
import useTranslation from '../../hooks/useTranslation';

const UserInfoSkeleton = () => {
    const viewType = useViewType();
    return (
        <div className="user-profile__info-wrapper">
            {viewType === ViewType.mobile ? (
                <Skeleton height={23} width={200} />
            ) : (
                <DarkSkeleton height={29} width={230} />
            )}
            {runningInRNWebView && <Skeleton className="user-profile__bank-name--skeleton" height={18} width={170} />}
        </div>
    );
};

const UserInfo: React.FC = () => {
    const translations = useTranslation();
    const { data: userInfo, isLoading, error, refetch } = useProfile();
    const { data: bankName } = useBankInfo();

    if (isLoading) {
        return <UserInfoSkeleton />;
    }

    if (error) {
        return (
            <ErrorCardWrapper
                className="user-profile__info-wrapper user-profile__error-card"
                exception={error as RequestExceptionWithResponse}
            >
                <ButtonWithSpinner buttonType="positive" showSpinner={isLoading} onClick={() => refetch()}>
                    {translations.tryAgain}
                </ButtonWithSpinner>
            </ErrorCardWrapper>
        );
    }
    const name = `${userInfo?.firstName || ''} ${userInfo?.lastName || ''}`;

    return (
        <div className="user-profile__info-wrapper">
            <h2 className="user-profile__user-name typography-h3">{name}</h2>
            {runningInRNWebView && bankName && bankName.value.length > 0 && (
                <p className="user-profile__bank-name">{bankName.value}</p>
            )}
        </div>
    );
};

export default UserInfo;
